import { render, staticRenderFns } from "./LoginItem.vue?vue&type=template&id=4f97456c&scoped=true&"
import script from "./LoginItem.vue?vue&type=script&lang=js&"
export * from "./LoginItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=4f97456c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97456c",
  null
  
)

export default component.exports